import React, { useState, useEffect } from "react";
import View from 'src/components/view';
import utils from 'src/components/utils';


const MemberkitEAD = function () {
  let [view, setView] = useState({});
  let [crud, setCrud] = useState({ data: {}, changed: {} });

  let [userMemberkit, setUserMemberkit] = useState(null);
  let [urlAcessoMemberkit, setUrlAcessoMemberkit] = useState(null);
  let [index, setIndex] = useState(0);
  let [ready, setReady] = useState(false);

  const loadUsuarioMemberkit = function () {
    utils.execute(crud, 'ead/memberkit/load_usuario', null, function (res) {
      if (res.data) {
        userMemberkit = res.data;
        setUserMemberkit(userMemberkit);
        urlAcessoMemberkit = userMemberkit.linkMagico;
        setUrlAcessoMemberkit(urlAcessoMemberkit);
        setIndex(index + 1);
        window.location.href = urlAcessoMemberkit;
      }
    }, true);
  }

  useEffect(() => {
    if (!ready) {
      ready = true;
      setReady(true);
      loadUsuarioMemberkit();
    }
  });

  return (
    <View styleClass="ui-full-page" name="memberkit_ead">
      {urlAcessoMemberkit && 
        <>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            height: '100vh',
            paddingTop: '40px',
            fontSize: '35px',
            fontWeight: '500px',
            textAlign: 'center'
          }}>
            <p>¿No puedes ver la página de la Academia Memberkit? Prueba con las instrucciones de abajo.</p>

            <img src="https://storage.googleapis.com/interpennweb-storage/assets/img/instruciones_memberkit2.png" />
          </div>
        </>
      }
    </View>
  );
}

export default MemberkitEAD;